import {action, observable} from "mobx";
import {Criterion} from "../domain/criterion/criterionDomain";
import {ProjectVersionParamValue} from "../domain/project/projectVersionParameterValueDomain";
import {SubCriterion} from "../domain/criterion/subCriterionDomain";
import {ProjectCriterionVersion} from "../domain/project/projectCriterionVersionDomain";
import SbToolProjectVersionService from "./projectVersionService";
import uiService from "../../core/common/service/uiService";
import {LovItem} from "../../core/metamodel/mdEntity";


class ParamsService {
  @observable public selectedCriterion : Criterion
  @observable public selectedSubCriterion : SubCriterion
  @observable public selectedCriterionVersion : ProjectCriterionVersion

  @observable public criterionVersionName: string

  public readonly paramsValues = observable<ProjectVersionParamValue>([])

  @observable public parametersLoaded : boolean;

  // recalculating project version params numbers
  // for example params 2,4,6 convert to 1,2,3 for correct saving on BE
  public recalculateParamsNumbers = () => {
    if (!this.selectedSubCriterion) {
      throw new Error("Sub criterion is not selected")
    }

    let newParamsValues : ProjectVersionParamValue[] = [];
    let oldParamsValues : ProjectVersionParamValue[] = this.paramsValues.peek();

    let paramsForCurrentSubCriterion = oldParamsValues.filter(p => this.selectedSubCriterion.parameters.find(sb => sb.paramId === p.parameter.paramId));
    let paramsForAnotherSubCriteria = oldParamsValues.filter(p => this.selectedSubCriterion.parameters.find(sb => sb.paramId === p.parameter.paramId) === undefined);

    let maxParamNumber = Math.max(... paramsForCurrentSubCriterion.map(p => p.paramNumber))
    if (isFinite(maxParamNumber)) {
      let currentParamNumber = 1;
      for (let i = 1; i <= maxParamNumber; i++) {
        let lineParams = paramsForCurrentSubCriterion.filter(p => p.paramNumber === i);
        // if line of params is empty, continue
        if (lineParams.length === 0) {
          continue;
        }
        lineParams.forEach(p => {
          p.paramNumber = currentParamNumber;
        })
        currentParamNumber++;
        newParamsValues.push(...lineParams);
      }
    }
    newParamsValues.push(...paramsForAnotherSubCriteria);
    this.paramsValues.replace(newParamsValues);
  }


  public getNextParamNumber = (subCriterion : SubCriterion) => {
    let numbersOfParams : number[] = this.paramsValues
      .filter(p => subCriterion.parameters.find(p1 => p1.paramId === p.parameter.paramId))
      .map(p => p.paramNumber)
    let paramNumber = 1;
    if (numbersOfParams.length > 0) {
      paramNumber = (Math.max(...numbersOfParams) + 1)
    }
    return paramNumber;
  }

  @action
  public loadResults = () => {
    let projectVersion = SbToolProjectVersionService.projectVersion.versionId;
    console.warn("Loading project version results");
    uiService.showToolbarActionFlag();
    SbToolProjectVersionService.getProjectVersionResults(projectVersion).then(results => {
      SbToolProjectVersionService.criterionResults = results
      uiService.hideToolbarActionFlag()
    })
  }

  @action
  public loadCriterionVersions = () => {
    let projectVersion = SbToolProjectVersionService.projectVersion.versionId;
    console.warn("Loading criteria versions");
    uiService.showToolbarActionFlag();
    SbToolProjectVersionService.readProjectCriteriaVersions(projectVersion).then(versions => {
      SbToolProjectVersionService.criterionVersions.replace(versions);
      uiService.hideToolbarActionFlag()
    });
  }

  @action
  public loadParams = () => {
    let criterion: Criterion = this.selectedCriterion
    let selectedCriterionVersion = this.selectedCriterionVersion;
    uiService.showToolbarActionFlag();
    console.warn("Loading params for criterion version " + selectedCriterionVersion.name)
    this.parametersLoaded = false;
    SbToolProjectVersionService.readProjectVersionValues(SbToolProjectVersionService.projectVersion.versionId, criterion.criterionId, selectedCriterionVersion.versionId).then(params => {
      this.paramsValues.replace(params)
      uiService.hideToolbarActionFlag()
      this.parametersLoaded = true;
    })
  }

  @action
  public selectCriterionVersion = (id? : number) => {
    let criterion: Criterion = this.selectedCriterion
    if (criterion) {
      if (id) {
        this.selectedCriterionVersion = SbToolProjectVersionService.criterionVersions.find(cv => cv.versionId === id);
      } else {
        this.selectedCriterionVersion = SbToolProjectVersionService.criterionVersions
          .find(cv => cv.criterion.criterionId === criterion.criterionId && cv.isDefault === true);
      }
      console.warn("Selected criterion version : " + this.selectedCriterionVersion.versionId);
      this.criterionVersionName = this.selectedCriterionVersion.name
      this.loadParams();
    }
  }
}

export default new ParamsService();



// WEBPACK FOOTER //
// ./src/sbtool/service/paramsService.ts